module.exports = __webpack_public_path__ + "img/ic-credit-check.f434cc71.svg";